<template>
  <div class="h-full flex flex-col">
    <h1 class="h-70px flex items-center justify-between border-inherit border-b-1">
      <span class=" ml-7px border-l-2 pl-8px border-color-primary">近期考试排名</span>
      <div>
        <el-select
          v-model="unitSelect"
          @change="changeExamSession"
          placeholder="请选择"
          class="w-150px"
          :popper-append-to-body="false"
        >
          <el-option
            v-for="(item, index) in examSessionList"
            :key="index"
            :label="item.name"
            :value="item.id"
            :title="item.name"
          ></el-option>
        </el-select>
        <el-link
          type="primary"
          class="ml-12px text-color-primary"
          @click="goExamRecord"
          >更多></el-link
        >
      </div>
    </h1>
    <div class="flex-auto overflow-y-auto" v-if="data.length">
      <div v-for="(item, index) in data" :key="index" class="flex h-54px items-center">
        <div
          class="w-18px h-18px rounded text-white text-12px flex justify-center items-center"
          :style="{ background: background(index + '') }"
        >
          {{ index + 1 }}
        </div>
        <div
          class="ml-10px h-full flex justify-between border-inherit border-solid border-b-1 items-center flex-auto pr-15px"
        >
          <span class="w-80px truncate cursor-pointer" :title="item.userName">{{
            item.userName
          }}</span>
          <span class="w-80px text-center">{{ item.score }}</span>
          <span class="w-80px text-right truncate">{{ item.department }}</span>
        </div>
      </div>
    </div>
    <div v-else class="h-40px leading-40px text-center text-gray-300">
      暂无数据
    </div>
  </div>
</template>
<script>
export default {
  name: 'ranking',
  props: {
    data: {
      default: () => {
        return []
      },
    },
    examSessionList: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  watch: {
    examSessionList(newV) {
      this.unitSelect = this.examSessionList[0]?.id
    },
  },
  data() {
    return {
      unitSelect: '',
    }
  },
  computed: {
    background() {
      return (val) => {
        let color
        switch (val) {
          case '0':
            color = '#FF3A30'
            break
          case '1':
            color = '#FF9502'
            break
          case '2':
            color = '#00BB7A'
            break
          default:
            color = '#c7c7cc'
        }
        return color
      }
    },
  },
  methods: {
    changeExamSession(val) {
      this.$emit('changeExamSession', val)
    },

    goExamRecord() {
      const url = Wiz?.globalSettings?.globalConfig?.routerBase
        ? `/${Wiz.globalSettings.globalConfig.routerBase}/educational-training-management-sm/exam-manage/exam-record`
        : '/educational-training-management-sm/exam-manage/exam-record'
      this.$router.push(url)
    }
  },
}
</script>
<style scoped lang="scss">
::v-deep .el-select-dropdown {
  width: 120px !important;
}
</style>
